import { useSelector } from "react-redux";

const GetRevisions = () => {
  const { allProjectRevisions } = useSelector(
    (state) => state.projectRevisionsReducer
  );

  let options = allProjectRevisions.map((el) => {
    const { rev } = el;
    return { label: rev, value: rev };
  });

  let defaultOption = [{ label: "00", value: "00" }];

  let revOptions = allProjectRevisions.length > 0 ? options : defaultOption;

  return [revOptions];
};

export default GetRevisions;
